var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737",
    transform: "translate(-2073.615 -2457.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M2075.46,2466.847a4.49,4.49,0,0,1-.527-.465,4.743,4.743,0,0,1,0-6.562,4.44,4.44,0,0,1,2.549-1.314v-.9l2.3,1.648-2.3,1.649v-1.085a3.218,3.218,0,0,0-1.665.918,3.427,3.427,0,0,0,0,4.74c.049.05.1.1.151.146Zm7.155-3.747a4.7,4.7,0,0,1-1.318,3.281,4.429,4.429,0,0,1-2.8,1.342v.876l-2.3-1.648,2.3-1.649v1.125a3.2,3.2,0,0,0,1.914-.958,3.427,3.427,0,0,0,0-4.74c-.049-.05-.1-.1-.151-.146l.508-1.231a4.544,4.544,0,0,1,.527.466A4.7,4.7,0,0,1,2082.615,2463.1Z",
    fill: "#1B453E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRing);
export default __webpack_public_path__ + "static/media/greenRing.8db7a4936dcd1c2f6880ba7d48c2c55f.svg";
export { ForwardRef as ReactComponent };